module.exports = __webpack_public_path__ + "static/media/orange.8d215cca.svg";